import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchAssets } from "../../../actions/sticker_maker/assetsActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Assets/_partials/_PageHeader";
import List from "../Assets/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";

const LIMIT = 42;

const Assets = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchAssets(params));
  }, [searchParams, currentPage, dispatch]);

  return (
    <PageLayout>
      <PageHeader />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            orderBy={
              {
                defaultKey: 'id',
                defaultSort: 'desc',
                items: [{ name: 'Date', key: 'id' }]
              }
            }
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Assets;
